function HomeQuoteResultModel(quoteResultResponse) {
	this.isCoverAvailable = quoteResultResponse.quoteResult.totalPremium !== undefined ;
	this.coverType = quoteResultResponse.dwellings[0].coverType;
	this.quoteResult = quoteResultResponse.quoteResult;
	this.paymentPlan = quoteResultResponse.paymentPlan;
	this.totalPremium = quoteResultResponse.quoteResult.totalPremium ;
	this.totalFSL = quoteResultResponse.quoteResult.totalFSL ;
	this.totalGST = quoteResultResponse.quoteResult.totalGST ;
	this.totalStampDuty = quoteResultResponse.quoteResult.totalStampDuty ;
	this.premiumAfterDiscount = quoteResultResponse.quoteResult.premiumAfterDiscount ;
	this.paymentFrequency = quoteResultResponse.paymentPlan ? quoteResultResponse.paymentPlan.paymentFrequency : null ;
	this.excess = quoteResultResponse.dwellings[0].excess ;
	this.cordelInfo = quoteResultResponse.dwellings[0].cordelInfo ;
	this.availableSumInsuredTypes = quoteResultResponse.dwellings[0].availableSumInsuredTypes;
	this.offering = quoteResultResponse.dwellings[0].offering;
	this.isStandardOffering = this.offering === 'QPHStandardOffering' ; 
	this.isPrestigeOffering = this.offering === 'QPHPrestigeOffering' ; 
	this.coverageOptions = quoteResultResponse.dwellings[0].coverageOptions ;
	this.response = quoteResultResponse ;

}
